import { makeStyles, Theme, withStyles, createStyles } from '@material-ui/core/styles';
import { red, blue, orange, pink } from '@material-ui/core/colors';
import { InputBase } from '@material-ui/core';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    title: {
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      fontSize: 18,
      color: 'black',
    },
    link: {
      cursor: 'pointer',
      marginRight: '5px',
      color: 'blue',
    },
    text: {
      marginLeft: '5px',
    },
    noLink: {
      cursor: 'pointer',
      textDecoration: 'none',
    },
    fixedHeight: {
      height: 240,
    },
    margin: {
      margin: theme.spacing(1),
    },
    select: {
      margin: theme.spacing(1),
      '& .MuiSelect-select:focus': {
        background: '#fff',
      },
    },
    search: {
      width: '50%',
    },
    box: {
      marginBottom: theme.spacing(2),
      width: '100%',
      display: 'flex',
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        gap: theme.spacing(1),
      },
    },
    flex: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    searchBar: {
      width: '380px',
      '@media (max-width: 768px)': {
        width: '100%',
        maxWidth: '300px',
      },
      '@media (max-width: 480px)': {
        maxWidth: '250px',
      },
    },
    noBorder: {
      border: 'none',
    },
    headerBtn: {
      boxShadow: 'none',
      textTransform: 'none',
      lineHeight: '36px',
      padding: `0 ${theme.spacing(3)}px`,
    },
    moreInfoBtn: {
      color: '#ff505f',
    },
    dateRangeButton: {
      width: 150,
      height: theme.spacing(4.5),
      fontSize: 14,
      textTransform: 'none',
      boxShadow: 'none',
      margin: theme.spacing(1),
      color: theme.palette.getContrastText(blue[500]),
      backgroundColor: blue[500],
      '&:hover': {
        backgroundColor: blue[700],
      },
    },
    dateRangePopUp: {
      position: 'absolute',
    },
    dataGrid: {
      width: '100%',
      overflowX: 'auto',
      '& .MuiDataGrid-root': {
        minWidth: '700px',
        '@media (max-width: 768px)': {
          minWidth: '600px',
        },
        '@media (max-width: 480px)': {
          minWidth: '500px',
        },
      },
      '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
      '& .row-background-error': {
        backgroundColor: red[50],
        '&:hover': {
          backgroundColor: red[100],
        },
      },
      '& .row-background-alert': {
        backgroundColor: pink[50],
        '&:hover': {
          backgroundColor: pink[100],
        },
      },
      '& .row-background-transaction': {
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: 'rgba(255, 80, 95, 0.04)',
        },
      },
      '& .cell-text-color-error': {
        color: pink[700],
      },
      '& .cell-text-color-alert': {
        color: orange[700],
      },
      '& .cell-text-color-transaction': {
        color: 'black',
        fontWeight: '500',
        textTransform: 'capitalize',
      },
      '& .MuiDataGrid-colCellTitle': {
        color: 'black',
        fontWeight: '700',
        textTransform: 'capitalize',
      },
      '@media (max-width: 768px)': {
        '& .MuiDataGrid-columnHeaders': {
          fontSize: '0.75rem',
          minHeight: '40px !important',
        },
        '& .MuiDataGrid-cell': {
          fontSize: '0.75rem',
          padding: '8px 4px',
        },
        '& .MuiDataGrid-row': {
          minHeight: '40px !important',
        },
        '& .MuiDataGrid-toolbarContainer': {
          flexDirection: 'column',
          alignItems: 'stretch',
          gap: '8px',
        },
      },
      '@media (max-width: 480px)': {
        '& .MuiDataGrid-columnHeaders': {
          fontSize: '0.7rem',
          minHeight: '36px !important',
        },
        '& .MuiDataGrid-cell': {
          fontSize: '0.7rem',
          padding: '6px 2px',
        },
        '& .MuiDataGrid-row': {
          minHeight: '36px !important',
        },
        '& .MuiDataGrid-toolbarContainer': {
          padding: '8px',
        },
        '& .MuiDataGrid-footerContainer': {
          flexDirection: 'column',
          alignItems: 'center',
          gap: '8px',
        },
      },
    },
    checkbox: {
      padding: theme.spacing(0, 1.5, 0, 0),
    },
  }),
  {
    index: 1,
  }
);

export const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
    },
    input: {
      width: '200px',
      padding: '16px 16px',
      marginLeft: theme.spacing(1),
      borderRadius: 4,
      position: 'relative',
      background: '#fff',
      fontSize: 14,
    },
  })
)(InputBase);
